// Take all informations from JSON on product page under 'JSON data metafields data'
// product-metafields-variants.js is the js for showing data based on selected variant               

document.addEventListener('DOMContentLoaded', function () {

    const productContainer = document.querySelector('[data-product-id]');
    const productId = productContainer ? productContainer.getAttribute('data-product-id') : null;

    if (!productId) {
        return;
    }

    const productJsonId = 'product-json-' + productId;
    const productJson = document.getElementById(productJsonId);

    if (!productJson) {
        console.error('Product JSON not found for product ID:', productId);
        return;
    }

    const productData = JSON.parse(productJson.innerText);
    const variants = productData.product.variants;

    function updatePrixPoids(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant) {
            const prixPoidsText = selectedVariant.metafields?.nutrition?._prix_poids;
            const prixPoidsContainer = document.getElementById('prix-poids-container');

            if (prixPoidsContainer) {
                if (prixPoidsText && prixPoidsText.trim() !== "") {
                    prixPoidsContainer.textContent = prixPoidsText;
                    prixPoidsContainer.hidden = false; 
                } else {
                    prixPoidsContainer.textContent = '';
                    prixPoidsContainer.hidden = true; 
                }
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updateSKU(variantId) {
       const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant) {
          const sku = selectedVariant.sku;
          const skuContainer = document.getElementsByClassName('product-sku__value')[0];
          if (skuContainer) {
              skuContainer.textContent = sku;
          }
        }
    }

    function updateNutritionInfo(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant) {
            const nutrition = selectedVariant.metafields?.nutrition;
            const custom = selectedVariant.metafields?.custom;
            const infoDietDosage = nutrition?.info_diet_dosage;
            const infoDiet = nutrition?.info_diet;
            const apport_reference_text = custom?.apport_reference_text;
            const info_nutritionnelle_bottom_text = custom?.info_nutritionnelle_texte_bas; 
   
            const nutritionContainer = document.querySelector('.infos_nutri-metafield');

            if (nutritionContainer) {
                nutritionContainer.innerHTML = '';

                if (infoDietDosage && infoDietDosage.trim() !== '') {
                    nutritionContainer.innerHTML += `
                        <p>${infoDietDosage || 'No dosage available'}</p>
                    `;
                }

                if (infoDiet && infoDiet.detail_nutritionnel && infoDiet.detail_nutritionnel.length > 0) {
                    nutritionContainer.innerHTML += `
                    <script id="characteristicsJson" type="application/json">${JSON.stringify(infoDiet.detail_nutritionnel)}</script>

                      <table class="characteristics-table">
                        <tbody>
                          ${infoDiet.detail_nutritionnel.map(detail => `
                            <tr>
                              <td class="legend">${detail.title}</td>
                              <td class="data">${detail.value} ${detail.unit} </td>
                              <td class="data">${detail.AR}</td>
                            </tr>
                          `).join('')}
                        </tbody>
                      </table>  
                      <div class="infos_nutri-bottom">
                        <div class="apport-reference-text-metafield">${apport_reference_text || ''}</div>
                        <div class="infos_nutri-bottom-text-metafield">${info_nutritionnelle_bottom_text || ''}</div>
                      </div>
                    `;
                }

                nutritionContainer.hidden = false;
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updateIngredients(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
    
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom; 
            const nutrition = selectedVariant.metafields?.nutrition;
            const composition_diet_table = custom?.composition_diet;
            const compositionDosage = nutrition?.composition_dosage;
            const price_per_kg = nutrition?._prix_poids;

            const ingredientContainer = document.querySelector('.ingredients-metafield');
    
            if (ingredientContainer) {

                ingredientContainer.innerHTML = '';
                  
                if (composition_diet_table && composition_diet_table.detail_composition && composition_diet_table.detail_composition.length > 0) {
                    ingredientContainer.innerHTML += `
                        <p>${compositionDosage || ''}</p>
                        <table class="characteristics-table">
                          <tbody>
                            ${composition_diet_table.detail_composition.map(detail => `
                              <tr>
                                <td class="legend">${detail.title}</td>
                                <td class="data">${detail.value} ${detail.unit} </td>
                              </tr>
                            `).join('')}
                          </tbody>
                        </table>
                        <div id="prix-poids-container" class="prix-poids-container">${price_per_kg || ''} </div>
                    `;
                }
    
                ingredientContainer.hidden = false;
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updatePreorder(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const next_delivery_date_text = custom?.next_delivery_date;
    
            const next_delivery_dateContainer = document.getElementById('estimated-shipping-preorder');
            const next_delivery_text_el = document.getElementById('back_in_stock_text');
            const next_delivery_text = next_delivery_text_el ? next_delivery_text_el.value : '';
            const ot_estimated_shipping = document.getElementById('ot-estimated-shipping');
          
            const deliveryInformationWrapper = document.getElementById('delivery-information_wrapper');
            const deliveryInfoInput = document.querySelector('#delivery_preoder_info');
          
            if (next_delivery_dateContainer) {
                if (next_delivery_date_text && deliveryInformationWrapper) {
                    deliveryInformationWrapper.style.display = 'block';
                }              
                if (next_delivery_date_text && next_delivery_date_text.trim() !== '') {
                    next_delivery_dateContainer.innerHTML = `<span>${next_delivery_text.trim()} <span class="delivery-product-information__preorder-date">${next_delivery_date_text}</span></span>`;
                    next_delivery_dateContainer.style.display = 'block'; 
    
                    if (ot_estimated_shipping) {
                        ot_estimated_shipping.style.display = 'none'; 
                    }
    
                    if (deliveryInfoInput) {
                        deliveryInfoInput.value = next_delivery_date_text.trim();
                    }
                } else {
                    next_delivery_dateContainer.innerHTML = '';
                    next_delivery_dateContainer.style.display = 'none'; 
    
                    if (ot_estimated_shipping) {
                        ot_estimated_shipping.style.display = 'block';
                    }
    
                    if (deliveryInfoInput) {
                        deliveryInfoInput.value = '';
                    }
                }
            } 
            
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updateClickCollect(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
      
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const delivery_click_collect = custom?.only_CC;
    
            const delivery_click_collectContainer = document.getElementById('delivery_click-collect');
            const delivery_informationContainer = document.getElementById('delivery-information_wrapper');
          
            if (delivery_click_collectContainer && delivery_informationContainer) {

                if (delivery_click_collect && delivery_click_collect.trim() !== '') {
                    delivery_click_collectContainer.style.display = 'block';
                    delivery_informationContainer.style.display = 'none';

                } else {
                    delivery_click_collectContainer.style.display = 'none';
                    delivery_informationContainer.style.display = 'block';
                }
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updateDenomination(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);
        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const denomination_legale_text = custom?.denomination_legale;  
            const ingredients_text = custom?.ingredients; 
    
            const denominationContainer = document.querySelector('.denomination-legal');
    
            if (denominationContainer) {

                denominationContainer.innerHTML = '';

                if (denomination_legale_text && denomination_legale_text.trim() !== '') {
                    denominationContainer.innerHTML += `
                        <p class="font-bold">${denomination_legale_text}</p>
                        <p>${ingredients_text || ''}</p>
                    `;
                }

                denominationContainer.hidden = false;
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }

    function updatePriceStriked(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant) {
            const custom = selectedVariant.metafields?.custom;
            const price_striked_text = custom?.prix_barre;  

            const price_strikedContainer = document.querySelector('.pack_price-striked');
    
            if (price_strikedContainer) {
                price_strikedContainer.innerHTML = '';
                if (price_striked_text && price_striked_text.trim() !== '') {
                    price_strikedContainer.innerHTML += `
                        <p>${price_striked_text}</p>
                    `;
                }
                price_strikedContainer.hidden = false;
            }
        } else {
            console.error('Variant not found for ID:', variantId);
        }
    }
  
    function updateLoyaltyPoints(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant && selectedVariant.metafields?.custom?.pourcentage_cagnotte) {
            const loyaltyPointsPercentage = selectedVariant.metafields.custom.pourcentage_cagnotte;
            
            const loyaltyPoints = (loyaltyPointsPercentage * 0.01 * selectedVariant.price * 0.01).toFixed(2);
            const loyaltyPoints2 = (Math.round((loyaltyPoints-0.004)*10)/10);
            const loyaltyPointsContainers = document.querySelectorAll('#cagnotte_card .cagnotte-block__points-container');
            if (loyaltyPointsContainers.length > 0) {
                loyaltyPointsContainers.forEach(function(container) {
                    container.innerText = loyaltyPoints2;
                });
            }
        }
    }

    function updateLivraisonLabel(variantId) {
        const selectedVariant = variants.find(variant => variant.id === variantId);

        if (selectedVariant) {
            const labelPresent = selectedVariant.metafields?.custom?.free_del;
            const currentLabelElementSelector = `[data-variant-id="${variantId}"] .product-label--custom`;
            const labelElement = document.querySelector(currentLabelElementSelector);
            if(labelElement) {
                if(labelPresent) {
                    labelElement.classList.remove('hidden');
                } else {
                    labelElement.classList.add('hidden');
                }
            }
        }
    }
  
    function getSelectedVariantId() {
        const selectedOptions = []; 
    
        if (document.querySelector('.kaching-bundles__bars')) {
            let optionSelector = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar--selected');
          
            if (optionSelector && optionSelector.querySelector('.kaching-bundles__bar-variant')) {
                let firstVariant = optionSelector.querySelector('.kaching-bundles__bar-variant');
                let selectElements = firstVariant.querySelectorAll('.kaching-bundles__bar-variant-select');            
        
                selectElements.forEach(select => {
                    let selectedOption = select.options[select.selectedIndex];
                    if (selectedOption) {
                        selectedOptions.push(selectedOption.textContent.trim().toLowerCase());
                    }
                });
            } else {
                if (productData && productData.product && productData.product.variants && productData.product.variants.length > 0) {
                    const singleVariant = productData.product.variants[0];
                    singleVariant.options.forEach(option => {
                        selectedOptions.push(option.trim().toLowerCase());
                    });
                }
            }          
        } else {
            document.querySelectorAll('.option-selector').forEach(optionSelector => {
                // Support hybride : lit Dropdown OU Bouton Radio coché
                const rawOption = optionSelector.querySelector("custom-select button span")?.textContent
                    ?? optionSelector.querySelector("input:checked")?.value
                    ?? optionSelector.querySelector("input:checked")?.closest("label")?.textContent
                    ?? "";

                if (rawOption) {
                    selectedOptions.push(rawOption.trim().toLowerCase());
                }
            });            
        }
    
        if (selectedOptions.length === 0) {
            console.log("No options selected.");
            return null;
        } else {
            const selectedVariant = variants.find(variant => {
                return variant.options.every((option, index) => option.trim().toLowerCase() === selectedOptions[index]);
            });
            return selectedVariant ? selectedVariant.id : null;
        }    
    }

    function handleSelectChange() {
        const selectedVariantId = getSelectedVariantId();
        if (selectedVariantId) {
            updateClickCollect(selectedVariantId);
            updatePreorder(selectedVariantId);
            updatePrixPoids(selectedVariantId);
            updateSKU(selectedVariantId);
            updateNutritionInfo(selectedVariantId);
            updateIngredients(selectedVariantId);
            updateDenomination(selectedVariantId);
            updatePriceStriked(selectedVariantId);
            updateLoyaltyPoints(selectedVariantId);
            updateLivraisonLabel(selectedVariantId);
        }
    }

    // 1. Écouteurs d'événements sur les éléments natifs (Dropdowns ET Boutons)
    document.querySelectorAll('.option-selector').forEach(optionSelector => {
        const customSelect = optionSelector.querySelector('custom-select');
        if (customSelect) {
            customSelect.addEventListener('change', handleSelectChange);
        }

        // AJOUT : Écouteur sur chaque bouton radio
        const radioInputs = optionSelector.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(input => {
            input.addEventListener('change', handleSelectChange);
        });
    });

    // 2. Écouteurs d'événements sur Kaching Bundles
    document.querySelectorAll('.kaching-bundles__bars').forEach(optionSelector => {
        const barSelector = optionSelector.querySelector('.kaching-bundles__bar--selected');
        if (barSelector) {
            const selectElements = barSelector.querySelectorAll('.kaching-bundles__bar-variant-select');
            selectElements.forEach(select => {
                select.addEventListener('change', handleSelectChange);
            });
        }
    });
    
    // 3. Observer pour Kaching Bundles
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                const updatedBarSelector = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar--selected');
                if (updatedBarSelector) {
                    const selectElements = updatedBarSelector.querySelectorAll('.kaching-bundles__bar-variant-select');
                    selectElements.forEach(select => {
                        select.removeEventListener('change', handleSelectChange);
                        select.addEventListener('change', handleSelectChange);
                    });
                }
            }
        });
    });
    
    const barsContainer = document.querySelector('.kaching-bundles__bars');
    if (barsContainer) {
        observer.observe(barsContainer, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    // 4. Initialisation automatique au chargement
    handleSelectChange();

    // 5. Délégation d'événements globale (Fallback complet)
    document.addEventListener('change', function(e) {
        if (
            e.target.matches('.kaching-bundles__bar-variant-select') ||
            e.target.matches('.option-selector select') ||
            e.target.matches('custom-select') ||
            e.target.matches('.option-selector input[type="radio"]') ||
            e.target.matches('.js-option')
        ) {
            handleSelectChange();
        }
    });

    document.addEventListener('input', function(e) {
        if (
            e.target.matches('.kaching-bundles__bar-variant-select') ||
            e.target.matches('.option-selector select') ||
            e.target.matches('custom-select') ||
            e.target.matches('.option-selector input[type="radio"]') ||
            e.target.matches('.js-option')
        ) {
            handleSelectChange();
        }
    });

});